import React from "react"
import {
	MdKeyboardArrowDown,
	MdKeyboardArrowUp,
	MdKeyboardArrowRight,
	MdKeyboardArrowLeft,
} from "react-icons/md"
import styled from "styled-components"

import { MobergFontSize } from "../../../../../Components/MobergFont/MobergFont"

interface ResizableCreditCardProps {
	cardRef: React.RefObject<HTMLDivElement>
	cardWidthPx: number
	cardHeightPx: number
}

export const ResizableCreditCard: React.FC<ResizableCreditCardProps> = ({
	cardRef,
	cardWidthPx,
	cardHeightPx,
}) => {
	return (
		<div style={{ position: "relative", display: "inline-block" }}>
			<Arrow as={MdKeyboardArrowDown} $direction="top" />
			<Arrow as={MdKeyboardArrowUp} $direction="bottom" />
			<Arrow as={MdKeyboardArrowRight} $direction="left" />
			<Arrow as={MdKeyboardArrowLeft} $direction="right" />
			<CreditCard
				tabIndex={0}
				ref={cardRef}
				aria-label="Calibration card"
				aria-describedby="calibration-instructions"
				style={{
					width: `${cardWidthPx}px`,
					height: `${cardHeightPx}px`,
				}}
			>
				<CardLabel id="calibration-instructions">
					Match your physical credit card to this outline
				</CardLabel>
			</CreditCard>
		</div>
	)
}

const ARROW_NUDGE_PX = -8

const Arrow = styled.div<{ $direction: "top" | "bottom" | "left" | "right" }>`
	position: absolute;
	color: var(--text-secondary-color);
	font-size: 24px;
	pointer-events: none;

	${({ $direction }) => {
		switch ($direction) {
			case "top":
				return `top: 0; left: 50%; transform: translate(-50%, calc(-100% - ${ARROW_NUDGE_PX}px));`
			case "bottom":
				return `bottom: 0; left: 50%; transform: translate(-50%, calc(100% + ${ARROW_NUDGE_PX}px));`
			case "left":
				return `left: 0; top: 50%; transform: translate(calc(-100% - ${ARROW_NUDGE_PX}px), -50%);`
			case "right":
				return `right: 0; top: 50%; transform: translate(calc(100% + ${ARROW_NUDGE_PX}px), -50%);`
		}
	}}
`

const CreditCard = styled.div`
	position: relative;
	border: 2px solid var(--color-text-primary);
	border-radius: 8px;
	background: repeating-linear-gradient(
		90deg,
		transparent,
		transparent 10px,
		var(--color-border-light) 10px,
		var(--color-border-light) 11px
	);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	outline: none;
	transition: box-shadow 120ms ease-in-out;

	&:focus {
		box-shadow: 0 0 0 3px rgba(32, 125, 234, 0.35);
	}
`

const CardLabel = styled.span`
	position: absolute;
	bottom: 12px;
	left: 12px;
	right: 12px;
	font-size: ${MobergFontSize.SMALL};
	width: fit-content;
	background: var(--color-surface-menu);
	padding: 4px 8px;
	border-radius: 6px;
	border: 1px solid var(--color-border-light);
	color: var(--color-text-primary);
`
